import React, { FC } from 'react'

import { IProduct } from 'shared/interfaces'
import ProductsListItem from '../ProductsListItem/ProductsListItem'

import { ProductsListProps } from './ProductsList.props'

const ProductsList: FC<ProductsListProps> = ({ productsList, units }) => (
  <>
    {productsList?.map((product: IProduct) => (
      <ProductsListItem key={product.id} product={product} units={units} />
    ))}
  </>
)

export default ProductsList
